import { writable } from "svelte/store";

export const selectedCandidateIdStore = writable(null);
